import { DateTime } from "luxon";

export type AssistantMessageFeedback = "useful" | "not_useful" | null;

export class AssistantMessage {
    constructor(
        public readonly id: number,
        public readonly role: string,
        public readonly content: string,
        public readonly sources: Record<string, unknown>[],
        public readonly metadata: Record<string, unknown> | null,
        public readonly feedback: AssistantMessageFeedback,
        public readonly feedbackComment: string,
        public readonly feedbackAt: DateTime | null,
        public readonly createdAt: DateTime,
    ) {}

    get isAssistant(): boolean {
        return this.role === "assistant";
    }

    get isUser(): boolean {
        return this.role === "user";
    }

    get isPending(): boolean {
        return this.metadata?.pending === true;
    }

    get isTemporary(): boolean {
        return this.metadata?.temporary === true;
    }
}
